import Colors from '../../../../shared/assets/style/default/color';
import styled from 'styled-components';

const AdsContainer = styled.div<React.CSSProperties>`
  background: ${Colors.background};
  height: 100%;
  overflow: hidden;
  position: absolute;
  width: 100%;
  z-index: 100;
`;

export default AdsContainer;
